var TorsoListView = require('backbone-torso/modules/ListView');
var PortalDataService = require('./../data-utils/PortalDataService');
var PatientWalletInsuranceListItemView = require('./PatientWalletInsuranceListItemView');
var patientWalletInsurancesTemplate = require('./patientWalletInsurancesTemplate.hbs');
var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');
var patientInsuranceCollection = require('./../insurance/patientInsuranceCollection');

/**
 * View for displaying a patients wallet insurances
 *
 * @class PatientWalletInsurancesView
 * @constructor
 */
module.exports = TorsoListView.extend(PortalDataService.mixin({
  tagName: 'section',
  className: 'index index--wallet',
  template: patientWalletInsurancesTemplate,
  itemView: PatientWalletInsuranceListItemView,
  itemContainer: 'wallet-insurance-items',

  dataModels: [
    {
      alias: 'patientInsurances',
      collectionType: 'patientInsurance',
      criteria: function() {
        return {
          isWalletInsurance: true
        };
      }
    }
  ],

  /**
   * @method initialize
   * @override
   * @param options {Object} configuration for this view
   * @param options.patientVecnaId {String} of the patient owning the payment methods
   */
  initialize: function(options) {
    options = options || {};
    this._patientVecnaId = options.patientVecnaId;
    patientInsuranceCollection.setPatientVecnaId(this._patientVecnaId);
    this.__itemContext = {patientVecnaId: this._patientVecnaId};
    this.collection = this.getPrivateCollection('patientInsurances');
    this.listenTo(this.collection, 'sync', this._removeFromCollection);

    financialFeatureConfigModel.loadOnce();
    this.listenTo(financialFeatureConfigModel, 'load-complete', this.render);
  },

  /**
   * Remove insurance from collection if savedToWallet is false
   * @method _removeFromCollection
   * @private
   */
  _removeFromCollection: function(model) {
    if (model.get('savedToWallet') === false) {
      this.collection.remove(model);
    }
  },

  /**
   * Re-fetches the data used by this view.
   * @method fetchContent
   */
  fetchContent: function() {
    this.forceFetch('patientInsurances');
  }
}));
